import config from "config/config";

export async function saveSurveyResponse(
  transactionId,
  userId,
  groupId,
  result
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      transactionId: transactionId,
      userId: userId || 0,
      surveyGroupId: groupId,
      surveyResponse: result,
    }),
  };

  const response = await fetch(config.REG_API_BASE_URL + "/Survey", options);

  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
